"use client";
import React, { createContext, useContext, useReducer } from "react";
import {
  UserDataContextType,
  userDataReducer,
  UserDataActionKind,
} from "./context-types";
import { UserProfileData } from "./types";

const UserDataContext: React.Context<UserDataContextType | null> =
  createContext<UserDataContextType | null>(null);

export function UserDataContextWrapper({
  children,
  initialState,
}: {
  children: React.ReactNode;
  initialState: UserProfileData;
}) {
  const [state, dispatch] = useReducer(userDataReducer, initialState);
  const updateMultipleFields = (payload: Partial<UserProfileData>): void => {
    dispatch({ type: UserDataActionKind.UPDATEMULTIPLEFILEDS, payload });
  };
  const updateField = (key: keyof UserProfileData, value: any): void => {
    dispatch({ type: UserDataActionKind.UPDATEFIELD, key, value });
  };

  return (
    <UserDataContext.Provider
      value={{
        state,
        updateMultipleFields,
        updateField,
      }}
    >
      {children}
    </UserDataContext.Provider>
  );
}

export function useUserDataContext() {
  const context = useContext(UserDataContext);
  if (!context) {
    throw new Error("Unable to use context for user data");
  }
  return context;
}
